<!--@format-->
<template>
    <div class="document-denial-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <div class="header-text">
                    <h3>Reason for denial</h3>
                </div>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div class="input-container">
                    <label :class="[{ invalid: !$v.denialReason.required && submitted }]"
                        >The Salesperson will receive an email with the reason for denial.</label
                    >
                    <app-textarea
                        v-model="denialReason"
                        :class="[{ invalid: !$v.denialReason.required && submitted }]"
                        auto-size
                        placeholder="What is your reason for denying this request"
                        :is-valid="$v.denialReason.required || !submitted"
                        error="Required"
                    />
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn transparent-btn" @click="closeWidget">
                        Go Back
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="sendDenial()">Send</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const AppButton = () => import('@/components/common/app-button.vue');
const AppTextArea = () => import('@/components/common/app-textarea.vue');
import EventBus from '@/scripts/event-bus.js';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'document-denial-widget',

    components: {
        'app-button': AppButton,
        'app-textarea': AppTextArea,
        'widget-close-svg': WidgetCloseSvg,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            denialReason: null,
            submitted: false,
        };
    },

    validations: {
        denialReason: {
            required,
        },
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        sendDenial() {
            if (!this.$v.$invalid) {
                EventBus.$emit('document:denied', this.denialReason);
                this.closeWidget();
            }
            this.submitted = true;
        },
    },
};
</script>

<style>
.document-denial-widget .invalid {
    color: #f30070;
}

.document-denial-widget.purple-gradient-header .widget-header {
    background: linear-gradient(264deg, #e38dee, #7a5bff);
}

.document-denial-widget.widget .content-wrapper {
    padding: 28px 45px 35px;
}

.document-denial-widget .app-textarea.invalid textarea,
.document-denial-widget .app-textarea.invalid textarea:focus {
    border-color: #f30070;
}

.document-denial-widget .app-textarea textarea {
    overflow: hidden;
}

.document-denial-widget .widget-contents-container .cancel-btn {
    border: 2px solid #cac6cb;
    color: #382153;
    width: 127px;
}

.document-denial-widget .widget-contents-container .action-container .app-button {
    width: 148px;
}

.document-denial-widget .widget-contents-container .transparent-btn {
    background: transparent;
}

.document-denial-widget .widget-contents-container .transparent-btn:hover {
    background: #dcdc;
}
</style>
